import "../../shared/sparkle_namespace.js";

window.Sparkle.Responsive ??= {};
